import { z } from 'zod';
import { MAX_TRASH_RETENTION_DAYS, MIN_TRASH_RETENTION_DAYS } from '../constants.js';
/**
 * Corbeille (FR — protection contre les pertes irréversibles). Un élément supprimé y reste
 * `retentionDays` jours, restaurable, avant purge définitive. La rétention est réglable par
 * organisation dans les paramètres.
 */
/**
 * Réglages de l'organisation, tels que **lus** par les paramètres. `shareHealthWithVendor` est en
 * lecture ici (pour afficher l'état courant), mais sa **mutation** passe par un endpoint dédié et
 * audité (`healthConsentSchema`, ADR-0037 §4), jamais par la mise à jour ordinaire ci-dessous.
 */
export const organizationSettingsSchema = z.object({
    /** Jours de rétention en corbeille avant purge. */
    retentionDays: z.number().int().min(MIN_TRASH_RETENTION_DAYS).max(MAX_TRASH_RETENTION_DAYS),
    /** Consentement au partage de l'état d'architecture avec l'éditeur (ADR-0037 §4). */
    shareHealthWithVendor: z.boolean(),
});
/**
 * Mise à jour ordinaire des réglages : **volontairement limitée à `retentionDays`**. Le consentement
 * fournisseur n'y figure pas — il a son propre endpoint audité, pour qu'une bascule ne passe jamais
 * inaperçue dans un PATCH générique.
 */
export const updateOrganizationSettingsSchema = z
    .object({
    retentionDays: z
        .number()
        .int()
        .min(MIN_TRASH_RETENTION_DAYS)
        .max(MAX_TRASH_RETENTION_DAYS)
        .optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Aucune modification fournie' });
const trashBase = z.object({
    id: z.string(),
    deletedAt: z.coerce.date(),
    /** Date de purge définitive prévue (deletedAt + rétention). */
    purgeAt: z.coerce.date(),
});
export const trashVideoSchema = trashBase.extend({
    title: z.string(),
    filename: z.string(),
});
export const trashImageSchema = trashBase.extend({
    videoId: z.string(),
    videoTitle: z.string(),
    timestampMs: z.number().int().nonnegative(),
    url: z.string().url(),
});
/** Vue complète de la corbeille de l'organisation. */
export const trashViewSchema = z.object({
    retentionDays: z.number().int().positive(),
    videos: z.array(trashVideoSchema),
    images: z.array(trashImageSchema),
});
//# sourceMappingURL=trash.js.map